// src/directives/uppercase.js
export default {
  beforeMount(el) {
    function handler(e) {
       // Prevent infinite loop by checking if the event is triggered by this directive
      if (e.inputType === 'insertFromPaste' || e.__fromDirective) {
        return;
      }

      const originalValue = el.value;
      const lowercaseValue = originalValue.toUpperCase();
      
      // Only process if the value actually changed
      if (originalValue !== lowercaseValue) {
        // Check if the input type supports selection range
        const supportsSelectionRange = el.setSelectionRange && (
          el.type === 'text' || 
          el.type === 'textarea' || 
          el.type === 'search' || 
          el.type === 'tel' || 
          el.type === 'password' ||
          !el.type // default to text
        );

        if (supportsSelectionRange) {
          // Store cursor/selection position BEFORE changing value
          const start = el.selectionStart;
          const end = el.selectionEnd;
          
          // Set the new value
          el.value = lowercaseValue;
          
          // Immediately restore cursor/selection position
          // Use requestAnimationFrame to ensure DOM is ready
          requestAnimationFrame(() => {
            try {
              el.setSelectionRange(start, end);
            } catch (error) {
              // Fallback: try setting just cursor position
              try {
                el.setSelectionRange(start, start);
              } catch (e) {
                console.warn('Could not set selection range:', error);
              }
            }
          });
        } else {
          //a) 2025-09-09-et doesn't work (have issues) for input types like email, number, url, etc.
          //b) the best way is not to use this type of input only use type text and validate with regex if needed.
          // For input types that don't support selection range (email, number, url, etc.)
          // We need a different approach to preserve cursor position
          
          if (el.type === 'email') {
            // For email inputs, use a different approach
            // Store the current cursor position (may be null for email inputs)
            const start = el.selectionStart;
            const end = el.selectionEnd;
            
            // Create a temporary text input to calculate proper cursor position
            const tempInput = document.createElement('input');
            tempInput.type = 'text';
            tempInput.value = originalValue;
            tempInput.style.position = 'absolute';
            tempInput.style.left = '-9999px';
            document.body.appendChild(tempInput);
            
            // Set cursor on temp input to match original
            if (start !== null && end !== null) {
              tempInput.setSelectionRange(start, end);
            }
            
            // Update temp input value and get new cursor position
            tempInput.value = lowercaseValue;
            const newStart = tempInput.selectionStart;
            const newEnd = tempInput.selectionEnd;
            
            // Update original email input
            el.value = lowercaseValue;
            
            // Try to set cursor position if possible
            requestAnimationFrame(() => {
              try {
                if (el.setSelectionRange && newStart !== null && newEnd !== null) {
                  el.setSelectionRange(newStart, newEnd);
                }
              } catch (e) {
                // Email inputs often don't support setSelectionRange
                console.debug('Could not set cursor position on email input');
              }
              
              // Clean up temp input
              document.body.removeChild(tempInput);
            });
          } else {
            // For other unsupported types, just set value
            el.value = lowercaseValue;
          }
        }
        
        // Dispatch a custom event to update v-model without triggering this handler again
        const customEvent = new Event('input', { bubbles: true });
        customEvent.__fromDirective = true;
        el.dispatchEvent(customEvent);
      }
    }
    el.__lowercaseHandler = handler;
    el.addEventListener('input', handler);
  },
  unmounted(el) {
    el.removeEventListener('input', el.__lowercaseHandler);
    delete el.__lowercaseHandler;
  }
};
